import clsx from 'clsx';
import * as prismicH from '@prismicio/helpers';

import { BaseSlice } from '../../components/BaseSlice';
import { Bounded } from '../../components/Bounded';
import { RichText } from '../../components/RichText';
import NewsletterArchiveComponent from '../../components/NewsletterArchive';

/**
 * @typedef {import("@prismicio/client").Content.NewsletterArchiveSlice} NewsletterArchiveSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<NewsletterArchiveSlice>} NewsletterArchiveProps
 * @type {import("react").FC<NewsletterArchiveProps>}
 */
const NewsletterArchive = ({ slice, index }) => {
  return (
    <Bounded as="section" index={index}>
      <BaseSlice>
        <div
          className={clsx(
            prismicH.isFilled.richText(slice.primary?.text) && 'mb-5'
          )}>
          <RichText field={slice.primary?.text} />
        </div>
        <NewsletterArchiveComponent list={slice._items} />
      </BaseSlice>
    </Bounded>
  );
};

export default NewsletterArchive;
